import { getBasicListItemStyles } from "./BasicListItem.styles";
import type { BasicListItemProps } from "./BasicListItem.types";
import { Button, Icon, Text } from "@/components/atoms";

export const BasicListItem = ({
  icon,
  color = "default",
  title,
  subtitle,
  value,
  action,
  actionIcon,
  onActionClick,
  customContent,
  customAction,
}: BasicListItemProps) => {
  const styles = getBasicListItemStyles({ customContent, color });

  if (customContent) {
    return <div className={styles.wrapper}>{customContent}</div>;
  }

  return (
    <div className={styles.wrapper}>
      {icon && (
        <Icon
          name={icon}
          color={color}
        />
      )}

      <div className={styles.textWrapper}>
        <Text variant="small">{title}</Text>

        {subtitle && <Text variant="caption">{subtitle}</Text>}
      </div>

      {action && (
        <div className={styles.actionWrapper}>
          <Button
            onClick={onActionClick}
            iconOnly
            icon={actionIcon}
            variant="ghost"
            size="sm"
          />
        </div>
      )}

      {value && (
        <Text
          className={`text-${color}`}
          variant="h6"
        >
          {value}
        </Text>
      )}
    </div>
  );
};
